import React from 'react';
import { Quran01Icon } from 'hugeicons-react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const QuranGuestCard = ({ isDarkMode, showNoThanksButton, onNoThanks }) => {
  const navigate = useNavigate();
  // Determine login path based on environment
  const loginPath = window.isUmmahtiNative ? '/' : '/login';
  const loginState = window.isUmmahtiNative ? { from: 'guestcta' } : { from: '/quran' };
  
  return (
    <motion.div 
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="py-12 text-center relative"
    >
      <img src="/images/empty_states/quran_empty_state.png" alt="Quran guest" className="w-70 h-70 mx-auto mb-6" />
      <h3 className={`text-xl font-medium mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Sign in to save your Quran progress</h3>
      <p className={`text-sm max-w-xs mx-auto ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Track your reading, sync across devices, and never lose your place in the Quran.</p>
      <div className="flex flex-col items-center gap-3 mt-6">
        <button
          onClick={() => navigate(loginPath, { state: loginState })}
          className={`w-64 px-6 py-2 rounded-full font-medium transition-all duration-200 shadow-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 ${
            isDarkMode
              ? 'bg-emerald-600 hover:bg-emerald-500 text-white'
              : 'bg-emerald-600 hover:bg-emerald-700 text-white'
          }`}
        >
          Sign In to Save Progress
        </button>
        {showNoThanksButton && (
          <button
            onClick={onNoThanks}
            className={`w-64 px-6 py-2 rounded-full font-medium border transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 ${
              isDarkMode
                ? 'bg-transparent border-gray-700 text-gray-400 hover:bg-gray-800/40'
                : 'bg-transparent border-gray-300 text-gray-500 hover:bg-gray-100'
            }`}
          >
            No, thanks
          </button>
        )}
      </div>
    </motion.div>
  );
};

export default QuranGuestCard; 